import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  CircularProgress,
  InputLabel,
  Radio,
  Dialog,
  RadioGroup,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Button,
  Tooltip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { CancelOutlined } from "@mui/icons-material";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import InputField from "components/Input";
import UploadFile from "components/UploadFile";
import DatePicker from "components/DatePicker";
import instance from "config/axios";
import routes from "services/System/routes";
import SystemServices from "services/System";
import {
  CleanTypes,
  Debounce,
  getFileSize,
  getYearMonthDateFormate,
  numberRegex,
  compareObjects,
} from "utils";
import TitleStatus from "data/Title_Status";
import styled from "@emotion/styled";
import Compressor from "compressorjs";
import ClientServices from "services/Client";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Add } from "@mui/icons-material";

import { FiDownload } from "react-icons/fi";

import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DeleteIcon from "@mui/icons-material/Delete";

import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import CustomerServices from "services/Customer";
import VehicleBookingServices from "services/VehicleBooking";
import { v4 as uuidv4 } from "uuid";
import ShippingServices from "services/Shipping";
import UserServices from "services/User";

// import { styled } from "@mui/system";

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "left",
    whiteSpace: "nowrap",
    backgroundColor: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "left",
    textWrap: "nowrap",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".css-1ru1j9e-MuiTableCell-root ": {
      color: "#ffffff",
      textAlign: "left",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const Input = styled("input")({
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  display: "block",
  opacity: 0,
  fontSize: 0,
  cursor: "pointer",
  zIndex: 1,
});

const HiddenInput = styled("input")({ display: "none" });

function ImageThumbSlider({ images = [], visibleCount = 8, onRemove }) {
  const [index, setIndex] = useState(0);
  const canSlide = images.length > visibleCount;
  const safeIndex = Math.min(index, Math.max(0, images.length - visibleCount));

  useEffect(() => {
    if (index !== safeIndex) setIndex(safeIndex);
  }, [images.length, visibleCount]);

  const maxIndex = Math.max(0, images.length - visibleCount);
  const next = () => setIndex((i) => Math.min(i + 1, maxIndex));
  const prev = () => setIndex((i) => Math.max(i - 1, 0));

  const THUMB = 140;
  const GAP = 12;
  const translateX = -(THUMB + GAP) * index;

  if (!images.length) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography sx={{ fontWeight: 600, mb: 1 }}>Preview</Typography>

      <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
        {canSlide && (
          <IconButton
            size="small"
            onClick={prev}
            disabled={index === 0}
            sx={{ mr: 1 }}
          >
            <ChevronLeftIcon />
          </IconButton>
        )}

        <Box
          sx={{
            overflow: "hidden",
            width: canSlide ? (THUMB + GAP) * visibleCount - GAP : "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: `${GAP}px`,
              transform: `translateX(${translateX}px)`,
              transition: "transform 240ms ease",
            }}
          >
            {images.map((src, i) => (
              <Box
                key={src + i}
                sx={{
                  width: THUMB,
                  height: THUMB,
                  borderRadius: 1.5,
                  overflow: "hidden",
                  border: "1px solid #E0E0E0",
                  position: "relative",
                  flex: "0 0 auto",
                }}
              >
                <img
                  src={src}
                  // alt={`upload-${i}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                {!!onRemove && (
                  <IconButton
                    onClick={() => onRemove(i)}
                    sx={{
                      minWidth: 0,
                      position: "absolute",
                      right: 4,
                      top: 4,
                      // px: 1,
                      // py: 0,
                      width: 24,
                      height: 24,
                      border: "1px solid #ddd",
                      borderRadius: "50%",
                      "&:hover": { bgcolor: "rgba(255,255,255,1)" },
                      fontSize: 10,
                      bgcolor: "#ffffffCC",
                      textTransform: "none",
                    }}
                  >
                    <DeleteIcon
                      sx={{
                        fontSize: "14px",
                        color: Colors.danger,
                      }}
                    />
                  </IconButton>
                )}
              </Box>
            ))}
          </Box>
        </Box>

        {/* Right arrow */}
        {canSlide && (
          <IconButton
            size="small"
            onClick={next}
            disabled={index === maxIndex}
            sx={{ ml: 1 }}
          >
            <ChevronRightIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}

export function AttachmentsCard({
  onPickFiles,
  onGetImages,
  images = [],
  onRemove,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item>
        <Box
          sx={{
            width: 350,
            minHeight: 150,
            p: 2.2,
            border: "1.5px dashed #C8D3C8",
            borderRadius: 2,
            bgcolor: "#F6FBF7",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <CloudUploadOutlinedIcon sx={{ fontSize: 18 }} />
            <label htmlFor="vehicle-images-input" style={{ cursor: "pointer" }}>
              <Typography
                component="span"
                sx={{ fontWeight: 600, fontSize: 14 }}
              >
                Upload Vehicle Images
              </Typography>
            </label>

            <Tooltip title="PNG/JPG • multiple files">
              <IconButton size="small" sx={{ p: 0, ml: 0.25 }}>
                <InfoOutlinedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>

            <HiddenInput
              id="vehicle-images-input"
              type="file"
              accept="image/png,image/jpg,image/jpeg"
              multiple
              onChange={onPickFiles}
            />
          </Box>

          <Typography sx={{ my: 1.2, color: "#7A7A7A", fontSize: 13 }}>
            or
          </Typography>

          <Button
            variant="outlined"
            size="small"
            onClick={onGetImages}
            sx={{
              textTransform: "none",
              borderColor: "#1B5E20",
              color: "#1B5E20",
              fontWeight: 600,
              px: 2.5,
              borderRadius: 1.2,
            }}
          >
            Get Images
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12} sm={12}>
        <ImageThumbSlider
          images={images}
          visibleCount={8}
          onRemove={onRemove}
        />
      </Grid>
    </Grid>
  );
}

function UpdateVehicleBookingV2() {
  const { id } = useParams();
  const navigate = useNavigate();
  const viewerRef = useRef();

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    setValue,
    control,
  } = useForm();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
  } = useForm();

  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pictureLoading, setPictureLoading] = useState(false);

  // *For Upload File types
  const allowFilesType = ["image/png", "image/jpg", "image/jpeg"];
  const allowFilesTypeInvoice = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
  ];

  const [expanded, setExpanded] = useState({
    customer: true,
    vehicle: false,
    Spec: false,
    title: false,
    info: false,
    Attachment: false,
  });

  // *For Customer Booking
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  // *For Buyer Id
  const [buyerId, setBuyerId] = useState([]);
  const [selectedBuyerId, setSelectedBuyerId] = useState(null);
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  // *For Currency
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  // *For Make
  const [makes, setMakes] = useState([]);
  const [selectedMake, setSelectedMake] = useState(null);

  // *For Models
  const [models, setModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);

  // *For Color
  const [colors, setColors] = useState([]);
  const [selectedColor, setSelectedColor] = useState(null);

  // *For Countries
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [staff, setStaff] = useState([]);

  // *For States
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);

  const [odometers, setOdometers] = useState([]);
  const [selectedOdometers, setSelectedOdometers] = useState(null);

  const [cylinders, setCylinders] = useState([]);
  const [selectedCylinders, setSelectedCylinders] = useState(null);

  const [drivetrain, setDrivetrain] = useState([]);
  const [selectedDrivetrain, setSelectedDrivetrain] = useState(null);

  const [fuel, setFuel] = useState([]);
  const [selectedFuel, setSelectedFuel] = useState(null);

  const [engineType, setEngineType] = useState([]);
  const [selectedEngineType, setSelectedEngineType] = useState(null);

  const [transmission, setTransmission] = useState([]);
  const [selectedTransmission, setSelectedTransmission] = useState(null);

  const [highlights, setHighlights] = useState([]);
  const [selectedHighlights, setSelectedHighlights] = useState(null);

  const [primaryDamage, setPrimaryDamage] = useState([]);
  const [selectedPrimaryDamage, setSelectedPrimaryDamage] = useState(null);

  // *For Title Status
  const [selectedTitleStatus, setSelectedTitleStatus] = useState(null);

  // *For Key
  const [key, setKey] = useState("yes");
  // *For Key
  const [relist, setRelist] = useState(false);
  const [titleIssue, setTitleIssue] = useState(false);
  // *For Pictures
  const [pictures, setPictures] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [detailData, setDetailData] = useState();
  // *For Handle Date
  const [titleReceiveDate, setTitleReceiveDate] = useState();
  const [purchaseDate, setPurchaseDate] = useState();
  const [pickupDate, setPickupDate] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [saleDate, setSaleDate] = useState();
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [allData, setAllData] = useState();
  const [warehouses, setWarehouses] = useState([]);
  // *For Save Prev & Updated Data
  const [prevData, setPrevData] = useState();
  const [updatedData, setUpdatedData] = useState();
  const [compareData, setCompareData] = useState([]);
  const [titleStatus, setTitleSatus] = useState("N/A");
  const [bookingCustomers, setBookingCustomers] = useState([]);
  const [selectedBookingCustomer, setSelectedBookingCustomer] = useState(null);

  const [documentLink2, setDocumentLink2] = useState("");
  const [progress2, setProgress2] = useState(0);
  const [uploadedSize2, setUploadedSize2] = useState(0);
  const [documentDetail2, setDocumentDetail2] = useState([]);

  // *For Vehicle Towers
  const [vehicleTowers, setVehicleTowers] = useState([]);
  const [selectedVehicleTower, setSelectedVehicleTower] = useState(null);

  const [selectedRate, setSelectedRate] = useState();
  const [invoice, setInvoice] = useState();

  // *For Dialog Box
  const [reviewUpdateDialog, setReviewUpdateDialog] = useState(false);

  const [selectedPictureIndex, setSelectedPictureIndex] = useState(0);
  const [selectedInvoiceIndex, setSelectedInvoiceIndex] = useState(0);
  const [invoicePictures, setInvoicePictures] = useState([]);
  const [progress, setProgress] = useState(0);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [documentDetail, setDocumentDetail] = useState([]);
  const [documentLink, setDocumentLink] = useState("");
  const [selectedPicture, setSelectedPicture] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCropping, setIsCropping] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [picSource, setPicSource] = useState(null);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [vinLength, setVinLength] = useState(false);
  const [invoiceType, setInvoiceType] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  // *For Title Status
  const [vehicleKey, setVehicleKey] = useState("N/A");
  const [vehicleCancell, setVehicleCancell] = useState("no");
  const [vehicleRelist, setVehicleRelist] = useState("no");
  const [filteredTitleStatus, setFilteredTitleStatus] = useState(TitleStatus);
  const [selectedCity, setSelectedCity] = useState(null);

  // *For Destination
  const [destinations, setDestinations] = useState([]);
  const [selectedDestination, setSelectedDestination] = useState({
    id: 1,
    name: "Jebel Ali, Dubai, UAE",
  });

  const [soldPrice, setSoldPrice] = useState(0);
  const [soldPriceAED, setSoldPriceAED] = useState(0);

  // Update sold price in state and calculate AED value
  const handleSoldPriceChange = (e) => {
    const value = e.target.value;
    setSoldPrice(value);
  };

  // Recalculate AED whenever sold price changes
  useEffect(() => {
    setSoldPriceAED(soldPrice * 3.675);
  }, [soldPrice]);

  const handlePictureClick = (index) => {
    setSelectedPicture(
      pictures[index].includes("https")
        ? pictures[index]
        : process.env.REACT_APP_IMAGE_BASE_URL + pictures[index],
    );
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsCropping(false);
    setSelectedPicture(null);
  };

  const handleBooking = async (value) => {
    try {
      let params = {
        page: 1,
        limit: 15,
        search: value,
      };

      const { data } = await ClientServices.getVehicleTT(params);

      if (data?.details) {
        // setValue("otherCharges", parseFloat(data?.details?.otherCharges).toFixed(2));
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleInvoiceClick = (index) => {
    viewerRef.current && viewerRef.current.click();

    // Move the clicked picture to index 0
    const updatedInvoices = [...invoicePictures];
    const clickedInvoice = updatedInvoices.splice(index, 1)[0];
    updatedInvoices.unshift(clickedInvoice);

    setInvoicePictures(updatedInvoices);
    setSelectedInvoiceIndex(0);
  };

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl); // Cleanup
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const handleDeleteDocument = (id) => {
    setInvoiceList((prev) => prev.filter((d) => d.id !== id));
  };

  const handleTitleStatusSearch = (searchTerm) => {
    if (searchTerm.trim() === "") {
      setFilteredTitleStatus(TitleStatus);
    } else {
      const filtered = TitleStatus.filter((status) =>
        status.name.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setFilteredTitleStatus(filtered);
    }
  };

  // *For Handle Date
  const handleTitleReceiveDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setTitleReceiveDate("invalid");
        return;
      }
      setTitleReceiveDate(newDate ? new Date(newDate) : newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const removeDoc = () => {
    try {
      setDocumentDetail([]);
      setDocumentLink("");
      // setValue2('scanned', '')
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadDocumentInvoices = async (e) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      let arr = [
        {
          id: uuidv4(),
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];
      if (allowFilesTypeInvoice.includes(file.type)) {
        setDocumentDetail2(arr);
        handleUploadInvoices(file, arr);
      } else {
        ErrorToaster(
          `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`,
        );
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadInvoices = async (file, docs) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress2(percentCompleted);
          setUploadedSize2(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail2(docs);
        setDocumentLink2(data?.data?.nations);
        SuccessToaster("Document Uploaded");
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleAddDocument = () => {
    if (!documentLink2) {
      ErrorToaster("Please upload a document before adding.");
      return;
    }

    if (!invoiceType?.id) return ErrorToaster("Please enter Invoice Type");

    setInvoiceList([
      ...invoiceList,
      {
        id: uuidv4(),
        invoiceType: invoiceType?.id,
        invoiceTypeName: invoiceType?.name,
        documentLink2,
      },
    ]);
    SuccessToaster("Document Added");
    setInvoiceType([]);
    setDocumentLink2("");
  };

  const getBookingCustomers = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await VehicleBookingServices.getBookingCustomers(params);
      setBookingCustomers(
        data?.filters.map((item) => {
          return { id: item?.customer_id, name: item?.customer_name };
        }),
      );
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getUsers = async (page, limit, search) => {
    try {
      const params = { page: 1, limit: 100, search };
      const { data } = await UserServices.getUsers(params);
      const rows = data?.users?.rows ?? [];

      const staffOnly = rows.filter((user) => user?.user_type_id === "S");

      const staffData = staffOnly.map((user) => ({
        id: user?.id,
        name: user?.name,
      }));

      setStaff(staffData);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handlePurchaseDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setPurchaseDate("invalid");
        return;
      }
      setPurchaseDate(newDate ? new Date(newDate) : newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handlePickupDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setPickupDate("invalid");
        return;
      }
      setPickupDate(newDate ? new Date(newDate) : newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleSaleDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setSaleDate("invalid");
        return;
      }
      setSaleDate(newDate ? new Date(newDate) : newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleDeliveryDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setDeliveryDate("invalid");
        return;
      }
      setDeliveryDate(newDate ? new Date(newDate) : newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Currencies
  const getCurrencies = async (defaultId) => {
    try {
      let params = {
        detailed: true,
      };
      const { data } = await SystemServices.getCurrencies(params);
      const currenciesArray = [];
      data?.currencies?.forEach((element) => {
        let obj = {
          id: element?.currency,
          name: element?.currency.toUpperCase(),
          rate: element?.conversion_rate,
        };
        currenciesArray.push(obj);
      });
      let finalCurrencies = currenciesArray.filter(
        (item) => item?.id != "aed" && item?.id != "cad",
      );
      setCurrencies(finalCurrencies);
      if (defaultId) {
        setSelectedCurrency(currenciesArray.find((e) => e?.id === defaultId));
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };
  // *For Get Vehicle Towers
  const getWarehouses = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getWarehouses(params);
      setWarehouses(data?.warehouses);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  // *For Get Makes
  const getMakes = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getMakes(params);
      setMakes(data?.makes?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Colors
  const getModels = async (id, search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        make_id: id,
        search: search,
      };
      const { data } = await SystemServices.getModels(params);
      setModels(data?.models?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Colors
  const getColors = async () => {
    try {
      const { data } = await SystemServices.getColors();
      setColors(
        data?.colors?.map((item) => {
          return { id: item, name: item };
        }),
      );
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Countries
  const getCountries = async (defaultId) => {
    try {
      const { data } = await SystemServices.getBusinessCountries();
      setCountries(data?.countries);
      if (defaultId) {
        setSelectedCountry(data?.countries.find((e) => e?.id === defaultId));
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get States
  // const getStates = async (countryId, defaultId) => {
  //   try {
  //     const { data } = await SystemServices.getBusinessLocation(countryId);
  //     const stateArr = data?.locations?.map((item) => {
  //       return { id: item.id, name: item?.state_code + "-" + item?.city_name };
  //     });
  //     setStates(stateArr);
  //     if (defaultId) {
  //       setSelectedState(stateArr.find((e) => e?.id === defaultId));
  //     }
  //   } catch (error) {
  //     ErrorToaster(error);
  //   }
  // };

  const getStates = async (countryId, defaultId) => {
    try {
      const { data } = await SystemServices.getBusinessLocation(countryId);
      let stateArr = data?.locations?.map((item) => {
        return { id: item.id, name: item?.state_code + "-" + item?.city_name };
      });

      // Deduplicate by id (in case backend returns duplicates)
      const uniqueStates = stateArr.filter(
        (state, index, self) =>
          index === self.findIndex((s) => s.id === state.id),
      );

      setStates(uniqueStates);

      if (defaultId) {
        setSelectedState(uniqueStates.find((e) => e?.id === defaultId));
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Customer Booking
  const getCustomerBooking = async (search, defaultId) => {
    try {
      let params = {
        name: search ?? "",
      };
      const { data } = await CustomerServices.getCustomerBooking(params);
      setCustomers(data?.customers);
      if (defaultId) {
        const detail = data?.customers.find((e) => e?.id === defaultId);
        // setSelectedCustomer(detail);
        if (detail) {
          setValue("customerId", detail.ref_id);
          setValue("contactNumber", detail.uae_phone);
          setValue("email", detail.email);
          setValue("masterId", detail?.master_id);
        }
        // setValue("customerId", detail?.ref_id);
        // setValue("contactNumber", detail?.uae_phone);
        // setValue("email", detail?.email);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Customer Buyer ID
  const getCustomerBuyerId = async (id, defaultId) => {
    try {
      let params = { customerID: id };
      const { data } = await CustomerServices.getCustomerBuyerId(params);
      setBuyerId(data?.details);
      if (defaultId?.id) {
        const findBuyerId = data?.details.find((e) => e?.id === defaultId?.id);
        const validId = findBuyerId ? findBuyerId : defaultId;
        setSelectedBuyerId(validId);
        setValue("auctioneer", validId?.auction?.name);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Set Customer Detail
  const setCustomerDetail = (data) => {
    if (data) {
      getCustomerBuyerId(data?.id);
      setValue("customerId", data?.ref_id);
      setValue("contactNumber", data?.uae_phone);
      setValue("email", data?.email);
    }
  };

  // *For Upload Document
  const allPictures = [...pictures];
  const removeExtension = (fileName) =>
    fileName.substring(0, fileName.lastIndexOf(".")) || fileName;
  const handleUploadDocument = async (e) => {
    setPictureLoading(true);

    try {
      e.preventDefault();
      const files = Array.from(e.target.files);

      const uploadPromises = [];

      for (let i = 0; i < files.length; i++) {
        const element = files[i];

        if (allowFilesType.includes(element.type)) {
          const promise = new Promise((resolve, reject) => {
            new Compressor(element, {
              quality: 0.8,
              success: (compressedFile) => {
                if (compressedFile instanceof File) {
                  handleUpload(compressedFile);
                  resolve(compressedFile);
                } else {
                  const compressedFileFromBlob = new File(
                    [compressedFile],
                    removeExtension(element.name),
                    {
                      type: compressedFile.type,
                    },
                  );
                  handleUpload(compressedFileFromBlob);
                  resolve(compressedFileFromBlob);
                }
              },
              error: reject,
            });
          });

          uploadPromises.push(promise);
        } else {
          ErrorToaster(
            `Only ${CleanTypes(allowFilesType)} formats are supported`,
          );
        }
      }

      // Wait for all promises to resolve
      const result = await Promise.all(uploadPromises);

      // Set the file input key outside the loop
      setFileInputKey(Date.now());
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const handleUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData);
      if (data) {
        allPictures.push(data?.data?.nations);
        Debounce(() => setPictures(allPictures));
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setPictureLoading(false);
    }
  };
  const handleUploadInvoice = async (file, docs) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress(percentCompleted);
          setUploadedSize(getFileSize(uploadedBytes));
        },
      });

      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail(docs);
        setDocumentLink(data?.data?.nations);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const handleUploadDocumentInvoice = async (e) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      let newFile = {
        id: uuidv4(),
        name: file?.name,
        file: "",
        type: file?.type.split("/")[1],
        size: getFileSize(file.size),
        isUpload: false,
      };

      if (allowFilesTypeInvoice.includes(file.type)) {
        // 🔥 Preserve previous files, only add new ones
        setDocumentDetail((prev) => [...prev, newFile]);
        setInvoices((prev) => [...prev, newFile]);
        handleUploadInvoice(file, [...documentDetail, newFile]);
      } else {
        ErrorToaster(
          `Only ${CleanTypes(allowFilesTypeInvoice)} formats are supported`,
        );
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getBookingCustomers();
    getUsers();
  }, []);

  useEffect(() => {}, [documentDetail]);

  // const handleUploadDocumentInvoice = async (e) => {
  //   try {
  //     e.preventDefault();
  //     const file = e.target.files[0];
  //     let arr = [
  //       {
  //         id: uuidv4(),
  //         name: file?.name,
  //         file: "",
  //         type: file?.type.split("/")[1],
  //         size: getFileSize(file.size),
  //         isUpload: false,
  //       },
  //     ];
  //     if (allowFilesTypeInvoice.includes(file.type)) {
  //       setDocumentDetail(arr);
  //       handleUploadInvoice(file, arr);
  //     } else {
  //       ErrorToaster(
  //         `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`
  //       );
  //     }
  //   } catch (error) {
  //     ErrorToaster(error);
  //   }
  // };
  // *For Remove Picture
  const removePicture = (event, index) => {
    event.preventDefault();
    try {
      let shallowPicture = [...pictures];
      shallowPicture.splice(index, 1);
      setPictures(shallowPicture);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Vehicle Booking Detail
  const getVehicleBookingDetail = async () => {
    setLoader(true);
    try {
      let params = { booking_id: id };
      const { data } =
        await VehicleBookingServices.getVehicleBookingDetail(params);
      setDetailData(data?.details);
      const { details } = data;
      setInvoice(details?.invoice);
      let prevObj = {
        customer_id: details?.customer?.id,
        customer_name: details?.customer?.name,
        buyer_id: details?.buyer?.name,
        master_id: details?.buyer?.master_id,
        // vin: details?.vin,s
        // lot_number: details?.lot_number,
        // currency: details?.currency.toUpperCase(),
        value: details?.value,
        other_charges: details?.other_charges,
        // make: details?.veh_make?.name,
        // model: details?.veh_model?.name,
        // color: details?.color,
        // country_id: details?.location?.country_name,
        // state_id: details?.location?.state_id,
        // key: details?.key,
        // is_relist: details?.is_relist,
        // vehicle_type: rateTypeOptions.find(
        //     (item) => item?.id == details?.vehicle_type
        // ).name,
        // title_status: details?.title_status,
        // is_title_issue: details?.is_title_issue,
        // title_issue: details?.title_issue,
        // title_receive_date: details?.title_receive_date,
        // purchase_date: details?.purchase_date,
        // auctioneer: details?.auctioneer,
        // pickup_date: details?.pickup_date,
        // delivery_date: details?.delivery_date,
        // pictures: details?.pictures,
        // towed_by: details?.tower?.name,
        // warehouse_id: details?.warehouse?.name,
        // notes: details?.notes,
        // destination_id: details?.destination?.name,
      };

      setSelectedBookingCustomer({
        id: details?.sale_agent_details?.id,
        name: details?.sale_agent_details?.name,
      });

      setSoldPriceAED(details?.sold_price);
      setSoldPrice(details?.sold_price / 3.675);
      setValue("remarks", details?.remarks);
      setValue("offSite", details?.off_site);
      setSelectedCustomer({
        id: details?.customer?.id, // Save the ID
        name: details?.customer?.name, // Save the name
      });
      // setSelectedCustomer(details?.customer?.id);
      setSelectedRate(
        rateTypeOptions.find((item) => item?.id == details?.vehicle_type),
      );
      setTitleSatus(
        details?.title_status_key == false
          ? "no"
          : details?.title_status_key == null
            ? "none"
            : "yes",
      );
      setPrevData(prevObj);
      setValue("customer", details?.customer_id);
      // setValue("customerId", details?.customer_id);
      setValue(
        "rate",
        rateTypeOptions.find((item) => item?.id == details?.vehicle_type),
      );
      setValue("vin", details?.vin);
      setValue("lotNumber", details?.lot_number);
      setValue("currency", details?.currency.toUpperCase());
      setValue("value", details?.value);
      setValue("otherCharges", details?.other_charges);
      setValue("make", details?.veh_make?.name);
      setValue("model", details?.veh_model?.name);
      setValue("color", details?.color);
      setValue("notes", details?.notes);
      setValue("country", details?.location?.country_name);
      setValue(
        "state",
        details?.location?.state_code + details?.location?.city_name,
      );
      setValue("city", details?.location?.name);
      setValue("titleStatus", details?.title_status);
      setValue("auctioneer", details?.auctioneer);
      setValue("buyerId", details?.buyer_id);
      setValue("masterId", details?.buyer?.master_id);
      setValue("title_issue", details?.title_issue);
      setValue("gpPin", details?.gp_pin);

      setValue(
        "vehicleTower",
        details?.tower?.name ? details?.tower?.name : "",
      );
      setValue("warehouse", details?.warehouse?.name);
      setValue(
        "bookingRate",
        parseFloat(details?.invoice?.booking_rate).toFixed(3),
      );
      if (details?.tower) {
        setSelectedVehicleTower({
          id: details?.tower?.id,
          name: details?.tower?.name,
        });
      }

      setKey(details?.key);
      setRelist(details?.is_relist);
      if (details?.is_relist) {
        setRelistReason({
          id: details?.relist_reason,
          name:
            details?.relist_reason === "non_payment"
              ? "Due to non-payment"
              : "Customer Request",
        });
      }
      setTitleIssue(details?.is_title_issue);

      setDocumentLink(data?.details?.invoices);
      if (data?.details?.invoices) {
        const filename = data.details.invoices.split("/").pop();
        const extension = filename.split(".").pop();

        const fileData = {
          id: uuidv4(),
          name: filename,
          file: data.details.invoices,
          type: extension,
          size: "N/A", // Optional: use helper to format size
          isUpload: true,
        };

        setDocumentDetail([fileData]);
      }

      // Set destination
      if (details?.destination_id) {
        const destinationMatch = destinations.find(
          (dest) => dest.id === details.destination_id,
        );
        if (destinationMatch) {
          setSelectedDestination(destinationMatch);
          setValue("destination", destinationMatch.name);
        } else {
          await getDestinations("", details.destination_id); // fallback to load and select
        }
      }

      setKeyLost(details?.key_lost ?? "no");

      setIsVehicleCancelled(details?.vehicle_cancelled ?? false);

      setSelectedMake(details?.veh_make);
      getModels(details?.veh_make?.id);
      setSelectedModel(details?.veh_model);
      setPictures(
        Array.isArray(details?.pictures) && details.pictures?.length > 0
          ? details.pictures
          : [],
      );
      setInvoicePictures(
        Array.isArray(details?.invoices) && details.invoices?.length > 0
          ? details.invoices
          : [],
      );
      setSelectedTitleStatus({
        id: details?.title_status,
        name: details?.title_status,
      });
      getCurrencies(details?.currency);
      getCountries(details?.country_id);
      if (details?.country_id) {
        getStates(details?.country_id, details?.location?.id);
      }
      setSelectedColor({ id: details?.color, name: details?.color });
      getCustomerBooking("", details?.customer_id);
      getCustomerBuyerId(details?.customer_id, details?.buyer);
      handleTitleReceiveDate(details?.title_receive_date);
      handlePurchaseDate(details?.purchase_date);
      setValue("purchaseDate", details?.purchase_date);
      handleSaleDate(details?.sale_date);
      setSelectedWarehouse(details?.warehouse);
      handlePickupDate(details?.pickup_date);
      handleDeliveryDate(details?.delivery_date);
      setAllData(data?.details?.customer);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!detailData) return; // wait until data is loaded

    // Auto-select based on detailData
    if (detailData.customer)
      setSelectedCustomer({
        id: detailData.customer.id,
        name: detailData.customer.name,
      });

    if (detailData.buyer)
      setSelectedBuyerId({
        id: detailData.buyer.id,
        name: detailData.buyer.name,
      });

    if (detailData.veh_make)
      setSelectedMake({
        id: detailData.veh_make.id || detailData?.make_id,
        name: detailData.veh_make.name || detailData?.make_name,
      });

    if (detailData.veh_model)
      setSelectedModel({
        id: detailData.veh_model.id || detailData?.model_id,
        name: detailData.veh_model.name || detailData?.model_name,
      });

    if (detailData.color)
      setSelectedColor({ id: detailData.color, name: detailData.color });

    if (detailData.location?.country_id)
      setSelectedCountry({
        id: detailData.location.country_id,
        name: detailData.location.country_name,
      });

    if (detailData.location)
      setSelectedState({
        id: detailData.location.id,
        name:
          detailData.location.state_code + "-" + detailData.location.city_name,
      });

    if (detailData.currency)
      setSelectedCurrency({
        id: detailData.currency.toLowerCase(),
        name: detailData.currency.toUpperCase(),
      });

    handlePurchaseDate(detailData?.purchase_date);
    setValue("purchaseDate", detailData?.purchase_date);
    setValue("titleDescription", detailData?.title_issue_desc);

    if (detailData?.cylinders_details)
      setSelectedCylinders({
        id: detailData?.cylinders_details?.id,
        name: detailData?.cylinders_details?.name,
      });

    if (detailData.title_status)
      setSelectedTitleStatus({
        id: detailData.title_status,
        name: detailData.title_status,
      });

    setSelectedEngineType({
      id: detailData?.engine_type_details?.id,
      name: detailData?.engine_type_details?.name,
    });

    setSelectedOdometers({
      id: detailData?.odometer_reading?.id,
      name: detailData?.odometer_reading?.name,
    });

    setSelectedHighlights({
      id: detailData?.highlights_details?.id,
      name: detailData?.highlights_details?.name,
    });

    setSelectedPrimaryDamage({
      id: detailData?.primary_damage_details?.id,
      name: detailData?.primary_damage_details?.name,
    });

    setSelectedTransmission({
      id: detailData?.transmission_details?.id,
      name: detailData?.transmission_details?.name,
    });

    setSelectedFuel({
      id: detailData?.fuel_type_details?.id,
      name: detailData?.fuel_type_details?.name,
    });

    setSelectedDrivetrain({
      id: detailData?.drive_train_details?.id,
      name: detailData?.drive_train_details?.name,
    });

    if (detailData.destination)
      setSelectedDestination({
        id: detailData.destination.id,
        name: detailData.destination.name,
      });

    if (
      detailData?.invoices_details &&
      Array.isArray(detailData.invoices_details)
    ) {
      const invoiceData = detailData.invoices_details.map((invoice) => ({
        id: invoice?.id,
        invoiceType: invoice?.doc_id,
        invoiceTypeName:
          invoice?.doc_id === 1
            ? "At the Time Of Purchase"
            : "At the Time Of Delivery",
        documentLink2: invoice?.invoice_attachment,
      }));

      setInvoiceList(invoiceData || []);
    }

    setValue("customer", detailData?.customer_id);
    setValue("customerId", detailData?.customer_id || detailData?.customer?.id);
    setValue(
      "rate",
      rateTypeOptions.find((item) => item?.id == detailData?.vehicle_type),
    );
    setValue("vin", detailData?.vin);
    setValue("lotNumber", detailData?.lot_number);
    setValue("currency", detailData?.currency?.toUpperCase());
    setValue("value", detailData?.value);
    setValue("otherCharges", detailData?.other_charges);
    setValue(
      "make",
      detailData?.make_name
        ? detailData?.make_name
        : detailData?.veh_make?.name,
    );
    setValue("model", detailData?.veh_model?.name || detailData?.model_name);
    setValue("color", detailData?.color);
    setValue("notes", detailData?.notes);
    setValue("country", detailData?.location?.country_name);
    setValue(
      "state",
      detailData?.location?.state_code + detailData?.location?.city_name,
    );
    setValue("city", detailData?.location?.name);
    setValue("titleStatus", detailData?.title_status);
    setValue("auctioneer", detailData?.auctioneer);
    setValue("buyerId", detailData?.buyer_id);
    setValue("title_issue", detailData?.title_issue);

    setValue(
      "vehicleTower",
      detailData?.tower?.name ? detailData?.tower?.name : "",
    );
    setValue("warehouse", detailData?.warehouse?.name);

    if (detailData.vehicle_type) {
      const found = rateTypeOptions.find(
        (r) => r.id === detailData.vehicle_type,
      );

      if (found) setSelectedRate(found);
      setValue("rateType", found);
    }

    // You can auto-set other booleans/dates too:
    setKey(detailData.key || "N/A");
    // setRelist(!!detailData.is_relist);
    setRelist(
      detailData.is_relist == false
        ? "no"
        : detailData.is_relist == null
          ? "none"
          : "yes",
    );
    // setTitleIssue(!!detailData.is_title_issue);
    setTitleIssue(
      detailData.is_title_issue == false
        ? "no"
        : detailData.is_title_issue == null
          ? "none"
          : "yes",
    );
    setKeyLost(
      detailData.key_lost == false
        ? "no"
        : detailData.key_lost == null
          ? "none"
          : "yes",
    );

    setVehicleKey(
      detailData.vehicle_key == false
        ? "no"
        : detailData.vehicle_key == true
          ? "yes"
          : "none",
    );

    setVehicleRelist(
      detailData.is_relist == false
        ? "no"
        : detailData.is_relist == true
          ? "yes"
          : "none",
    );

    setValue("relistReason", detailData?.relist_reason);

    setVehicleCancell(
      detailData.vehicle_cancelled == false
        ? "no"
        : detailData.vehicle_key == true
          ? "yes"
          : "none",
    );

    setTitleSatus(
      detailData.title_status_key == false
        ? "no"
        : detailData.title_status_key == true
          ? "yes"
          : "none",
    );
  }, [detailData]);

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded((prev) => ({ ...prev, [panel]: isExpanded }));
  };

  // *For Get Update Picture
  const getUpdateVehiclePicture = async () => {
    try {
      let obj = {
        pictures,
        vin: getValues("vin"),
        booking_id: id,
        pic_source: picSource,
      };
      const { data, message } = await VehicleBookingServices.updatePicture(obj);
      SuccessToaster(message);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Check Updated data
  const checkUpdatedData = async (formData) => {
    try {
      // Prepare the object with the fields we care about for approval
      let obj = {
        customer_id: selectedCustomer?.id,
        customer_name: selectedCustomer?.name,
        // buyer_id:  selectedBuyerId?.id,
        // master_id: formData?.masterId,
        value: formData.value,
        other_charges: formData.otherCharges ? formData.otherCharges : 0,
      };

      // Check if any of the approval fields have changed
      const approvalDataChanged =
        prevData?.customer_id !== obj.customer_id ||
        prevData?.customer_name !== obj.customer_name ||
        prevData?.value !== obj.value ||
        prevData?.other_charges !== obj.other_charges;
      //  ||
      // prevData?.buyer_id !== obj.buyer_id ||
      // prevData?.master_id !== obj.master_id;

      // Prepare the updateDataObj for fields that will directly be added to the update booking
      let updateDataObj = {
        customer_id: selectedCustomer?.id,
        customer_name: selectedCustomer?.name,
        // buyer_id: selectedBuyerId?.id,
        // master_id: formData?.masterId,
        value: formData.value,
        other_charges: formData.otherCharges ? formData.otherCharges : 0,

        // vin: formData.vin,
        // vehicle_cancelled: vehicleCancell,

        // lot_number: formData.lotNumber,
        // make: selectedMake?.id,
        // model: selectedModel?.id,
        // color: selectedColor?.id,
        // country_id: selectedCountry?.id,
        // location_id: selectedState ? selectedState?.id : null,
        // key: key,
        // key_lost: keyLost,
        // vehicle_key: vehicleKey,
        // vehicle_cancelled: isVehicleCancelled,
        // is_relist: vehicleRelist,
        // relist_reason: vehicleRelist ? formData?.relistReason : null,
        // is_title_issue: titleIssue,
        // title_issue_description: titleIssue ? formData?.titleDescription : null,
        // title_issue_key: titleIssue,
        // title_status: selectedTitleStatus?.id,
        // title_status_key: titleStatus,
        // title_receive_date: getYearMonthDateFormate(titleReceiveDate),
        // currency: selectedCurrency?.id,
        // vehicle_type: rateTypeOptions.find(
        //     (item) => item?.id == selectedRate?.id
        // ).id,
        // purchase_date: getYearMonthDateFormate(purchaseDate),
        // auctioneer: formData.auctioneer,
        // pickup_date: getYearMonthDateFormate(pickupDate),
        // delivery_date: getYearMonthDateFormate(deliveryDate),
        // pictures: pictures,
        // towed_by: selectedVehicleTower?.id,
        // warehouse_id: selectedWarehouse?.id,
        // notes: getValues("notes"),
        // invoices: documentLink,
        // destination_id: selectedDestination?.id,
      };

      const data =
        compareObjects(prevData, {
          ...obj,
          invoices: documentDetail,
        }) || [];

      const prevValueArray = data?.map((item) => ({
        key: item.key,
        value: item.prevValue,
      }));
      const updateValueArray = data?.map((item) => ({
        key: item.key,
        value: item.updateValue,
      }));

      // Payload for update booking (directly update these fields without approval)
      const payload = {
        ...updateDataObj,
        new_data: updateValueArray,
        old_data: prevValueArray,
        vin: formData.vin,
        lot_number: formData.lotNumber,
        make: selectedMake?.id,
        model: selectedModel?.id,
        color: selectedColor?.id,
        country_id: selectedCountry?.id,
        location_id: selectedState ? selectedState?.id : null,
        key: key,
        key_lost: keyLost,
        vehicle_cancelled: vehicleCancell,
        is_relist: vehicleRelist,
        relist_reason: vehicleRelist ? formData?.relistReason : null,
        is_title_issue: titleIssue,
        title_issue: titleIssue ? formData?.title_issue : null,
        title_status: selectedTitleStatus?.id,
        title_receive_date: getYearMonthDateFormate(titleReceiveDate),
        currency: selectedCurrency?.id,
        vehicle_type: rateTypeOptions.find(
          (item) => item?.id == selectedRate?.id,
        ).id,
        purchase_date: getYearMonthDateFormate(purchaseDate),
        auctioneer: formData.auctioneer,
        pickup_date: getYearMonthDateFormate(pickupDate),
        delivery_date: getYearMonthDateFormate(deliveryDate),
        pictures: pictures,
        towed_by: selectedVehicleTower?.id,
        warehouse_id: selectedWarehouse?.id,
        notes: getValues("notes"),
        invoices: documentLink,
        destination_id: selectedDestination?.id,
        title_issue_desc: formData?.titleDescription,
      };

      if (approvalDataChanged) {
        setUpdatedData(payload);
        setCompareData(data);
        setReviewUpdateDialog(true);
      } else {
        await updateVehicleBooking(formData, payload);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const isSyntheticEvent = (val) => {
    return (
      val &&
      typeof val === "object" &&
      ("nativeEvent" in val || "_reactName" in val) &&
      typeof val.preventDefault === "function"
    );
  };

  // *For Update Vehicle Booking

  const updateVehicleBooking = async (formData, payloadOverride = null) => {
    const useOverride =
      payloadOverride && !isSyntheticEvent(payloadOverride)
        ? payloadOverride
        : null;
    setLoading(true);
    try {
      let obj;

      if (useOverride) {
        obj = {
          ...useOverride,
          booking_id: parseInt(id),
          ex_rate: selectedCurrency?.rate ?? null,
          comment: formData.comment ?? null,
          odometer: selectedOdometers?.id,
          transmission: selectedTransmission?.id,
          cylinders: selectedCylinders?.id,
          fuel_type: selectedFuel?.id,
          drive_train: selectedDrivetrain?.id,
          engine_type: selectedEngineType?.id,
          highlights: selectedHighlights?.id,
          primary_damage: selectedPrimaryDamage?.id,
          invoice_documents: invoiceList.map((d) => ({
            doc_id: d.invoiceType,
            booking_id: parseInt(id),
            invoice_attachment: d.documentLink2,
          })),
        };
      } else {
        obj = {
          ...updatedData,
          booking_id: parseInt(id),
          ex_rate: selectedCurrency?.rate ?? null,
          comment: formData.comment ?? null,
          odometer: selectedOdometers?.id,
          transmission: selectedTransmission?.id,
          cylinders: selectedCylinders?.id,
          fuel: selectedFuel?.id,
          drivetrain: selectedDrivetrain?.id,
          engine_type: selectedEngineType?.id,
          highlights: selectedHighlights?.id,
          primary_damage: selectedPrimaryDamage?.id,
          invoice_documents: invoiceList.map((d) => ({
            doc_id: d.invoiceType,
            booking_id: parseInt(id),
            invoice_attachment: d.documentLink2,
          })),
        };
      }

      const { message } =
        await VehicleBookingServices.updateVehicleBooking(obj);
      SuccessToaster(message);
      setReviewUpdateDialog(false);
      if (useOverride) {
        navigate("/vehicle-booking-list");
      } else {
        navigate("/approval-list");
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  // *For Create Make
  const createMake = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createMake(obj);
      getMakes();
      setSelectedMake(data?.make);
      setValue("make", data?.make?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Create Model
  const createModel = async (name) => {
    try {
      let obj = {
        name: name,
        make_id: selectedMake?.id,
      };
      const { data } = await SystemServices.createModel(obj);
      getModels(obj?.make_id);
      setSelectedModel(data?.model);
      setValue("model", data?.model?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const rateTypeOptions = [
    { id: 1, name: "Normal Bike" },
    { id: 2, name: "Oversize Bike" },
    { id: 3, name: "Auto" },
    { id: 4, name: "Container Price" },
    { id: 5, name: "Scrap Price" },
    { id: 6, name: "Cutting" },
  ];

  // *For Get Vehicle Towers
  const getVehicleTowers = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getVehicleTowers(params);
      setVehicleTowers(data?.towing?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Create Color
  const createColor = async (name) => {
    try {
      let obj = {
        color: name,
      };
      const { data } = await SystemServices.createColor(obj);
      getColors();
      setSelectedColor({ id: data?.color, name: data?.color });
      setValue("color", data?.color);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getOdometers = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getOdometer(params);
      setOdometers(data?.highlights?.rows || []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const createOdometers = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createOdometer(obj);
      getOdometers();
      setSelectedOdometers(data?.odometers);
      setValue("odoMeters", data?.odometers?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const createCylinders = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createCylinders(obj);
      getCylinders();
      setSelectedCylinders(data?.cylinder);
      setValue("cylinders", data?.cylinder?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getCylinders = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getCylinders(params);
      setCylinders(data?.cylinders?.rows || []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const createDrivetrain = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createDriveTrains(obj);
      getDrivetrain();
      setSelectedDrivetrain(data?.driveTrains);
      setValue("drivetrain", data?.driveTrains?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getDrivetrain = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getDriveTrains(params);
      setDrivetrain(data?.driveTrains?.rows || []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const createFuel = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createFuelTypes(obj);
      getFuel();
      setSelectedFuel(data?.fuelType);
      setValue("fuel", data?.fuelType?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getFuel = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getFuelTypes(params);
      setFuel(data?.fuelTypes?.rows || []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getEngineType = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getEnginTypes(params);
      setEngineType(data?.driveTrains?.rows || []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const createEngineType = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createEnginTypes(obj);
      getEngineType();
      setSelectedEngineType(data?.engineType);
      setValue("engineType", data?.engineType?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getTransmission = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getTransmission(params);
      setTransmission(data?.transmissions?.rows || []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const createTransmission = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createTransmission(obj);
      getTransmission();
      setSelectedTransmission(data?.transmissions);
      setValue("transmission", data?.transmissions?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const createHighlights = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createHighlights(obj);
      getHighlights();
      setSelectedHighlights(data?.highlights);
      setValue("highlights", data?.highlights?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getHighlights = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getHighlights(params);
      setHighlights(data?.highlights?.rows || []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const createPrimaryDamage = async (name) => {
    try {
      let obj = {
        name: name,
      };
      const { data } = await SystemServices.createPrimaryDamages(obj);
      getPrimaryDamage();
      setSelectedPrimaryDamage(data?.primaryDamages);
      setValue("primaryDamage", data?.primaryDamages?.name);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const getPrimaryDamage = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        search: search,
      };
      const { data } = await SystemServices.getPrimaryDamages(params);
      setPrimaryDamage(data?.primaryDamages?.rows || []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    if (id) {
      getVehicleBookingDetail();
      getMakes();
      getCylinders();
      getDrivetrain();
      getEngineType();
      getFuel();
      getTransmission();
      getOdometers();
      getHighlights();
      getPrimaryDamage();
      getColors();
      getVehicleTowers();
      getWarehouses();
      getDestinations();
    }
  }, [id]);

  const removeInvoicePicture = (index) => {
    try {
      let shallowPicture = [...invoicePictures];
      shallowPicture.splice(index, 1);
      setInvoicePictures(shallowPicture);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const getImages = async (vin) => {
    try {
      let params = {
        vin: vin,
      };
      setLoading(true);
      const { data } = await ShippingServices.getShippingInfo(params);
      setLoading(false);
      if (data?.vehicle?.data?.images?.length > 0) {
        setPicSource("W8");
        setPictures(
          Array.isArray(data?.vehicle?.data?.images) &&
            data?.vehicle?.data?.images?.length > 0
            ? data?.vehicle?.data?.images
            : [],
        );
      } else {
        ErrorToaster("No Images Found");
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const handleCropClick = (index) => {
    const imageSrc = pictures[index].includes("https")
      ? pictures[index]
      : process.env.REACT_APP_IMAGE_BASE_URL + pictures[index];

    setSelectedPicture(imageSrc);
    setIsCropping(true);
  };

  const handleCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };
  const saveCroppedImage = async (index) => {
    if (!pictures || !pictures[index]) {
      console.error("Invalid index or pictures array:", { pictures, index });
      return;
    }

    const imageSrc = pictures[index].includes("https")
      ? pictures[index]
      : process.env.REACT_APP_IMAGE_BASE_URL + pictures[index];

    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = imageSrc;

    image.onload = async () => {
      const canvas = document.createElement("canvas");
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
      );
      try {
        // Convert the canvas to a Blob for uploading
        canvas.toBlob(async (blob) => {
          if (!blob) {
            console.error("Failed to create a Blob from the canvas.");
            return;
          }
          // Create a FormData object to send the cropped image to the server
          const formData = new FormData();
          formData.append("document", blob);
          // Upload the cropped image to the server
          const { data } = await instance.post(
            routes.uploadDocuments,
            formData,
          );

          if (data) {
            // Replace the original picture URL with the new cropped image URL
            pictures[index] = imageSrc;
            setIsCropping(false);
          } else {
            console.error("Failed to upload the cropped image.");
          }
        }, "image/jpeg");
      } catch (error) {
        console.error("Error processing cropped image:", error);
      }
    };

    image.onerror = (error) => {
      console.error("Failed to load image:", error);
    };
  };
  const [relistReason, setRelistReason] = useState(null);
  const [keyLost, setKeyLost] = useState("no"); // null, "yes", or "no"
  const [isVehicleCancelled, setIsVehicleCancelled] = useState(false);
  useEffect(() => {
    if (!relist) {
      setRelistReason(null);
    }
  }, [relist]);
  const getDestinations = async (search, defaultId) => {
    try {
      const params = {
        page: 1,
        limit: 50,
        search,
      };
      const { data } = await SystemServices.getDestinations(params);
      const destinationList = data?.destinations?.rows || [];
      setDestinations(destinationList);

      if (defaultId) {
        const match = destinationList.find((dest) => dest.id === defaultId);
        if (match) {
          setSelectedDestination(match);
          setValue("destination", match.name);
        }
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  return (
    <Box
      className="your-component-container"
      sx={{
        m: 4,
        p: 5,
        bgcolor: Colors.white,
        borderRadius: 3,
        boxShadow: "0px 8px 18px 0px #9B9B9B1A",
      }}
    >
      <Dialog
        open={reviewUpdateDialog}
        sx={{
          "& .MuiDialog-paper": {
            width: "40%",
            height: "auto",
            borderRadius: 2,
            py: { xs: 2, md: 4 },
            px: { xs: 3, md: 6 },
          },
        }}
      >
        <IconButton
          onClick={() => setReviewUpdateDialog(false)}
          sx={{ position: "absolute", right: 13, top: 13 }}
        >
          <CancelOutlined />
        </IconButton>
        <Box>
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              color: Colors.charcoalGrey,
              fontFamily: FontFamily.NunitoRegular,
              mt: 1,
              mb: 1.5,
            }}
          >
            Review Updates
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit2(updateVehicleBooking)}
            sx={{ mt: 4 }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="body1"
                  sx={{ color: Colors.charcoalGrey, mb: 1.5 }}
                >
                  Old Data
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="body1"
                  sx={{ color: Colors.charcoalGrey, mb: 1.5 }}
                >
                  New Data
                </Typography>
              </Grid>
              {compareData
                ?.filter((item) => !item?.key?.includes("pictures")) // Exclude "pictures"
                .map((item, index) => (
                  <Fragment key={index}>
                    <Grid item xs={12} sm={6}>
                      <InputField
                        disabled={true}
                        value={item?.prevValue}
                        label={item?.key.split("_").join(" ")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputField
                        disabled={true}
                        value={item?.updateValue}
                        label={item?.key.split("_").join(" ")}
                      />
                    </Grid>
                  </Fragment>
                ))}
              <Grid item xs={12} sm={12}>
                <InputField
                  multiline={true}
                  rows={4}
                  label={"Comment"}
                  placeholder={"Comment"}
                  error={errors2?.comment?.message}
                  register={register2("comment", {
                    required: "Please enter the comment.",
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "right" }}>
                <PrimaryButton
                  title="Send edit for approval"
                  type="submit"
                  loading={loading}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Dialog>

      {loader && (
        <div className="bookingoverlay">
          {" "}
          <CircularProgress />{" "}
        </div>
      )}

      <Box component="form" onSubmit={handleSubmit(checkUpdatedData)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography
              variant="h5"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
                mb: 4,
              }}
            >
              Edit Vehicle Booking V2
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Accordion
              expanded={!!expanded.customer}
              onChange={handleChange("customer")}
              sx={{
                backgroundColor: "transparent",
                boxShadow: "none",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Customer Details*</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Grid container spacing={2} sx={{ mt: 0 }}>
                  <Grid item xs={12} sm={4}>
                    <SelectField
                      onSearch={(v) => getCustomerBooking(v)}
                      label={"Select Customer*"}
                      options={customers}
                      selected={selectedCustomer}
                      onSelect={(value) => {
                        setSelectedCustomer(value);
                        setCustomerDetail(value);
                      }}
                      error={errors?.customer?.message}
                      register={register("customer", {
                        required: "Please select customer.",
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputField
                      disabled={true}
                      label={"Customer ID"}
                      placeholder={"Customer ID"}
                      register={register("customerId")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputField
                      disabled={true}
                      label={"Master ID"}
                      placeholder={"Master ID"}
                      register={register("masterId")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <SelectField
                      disabled={selectedCustomer ? false : true}
                      label={"Buyer ID*"}
                      options={buyerId}
                      selected={selectedBuyerId}
                      onSelect={(value) => {
                        setSelectedBuyerId(value);
                        setValue("auctioneer", value?.auction?.name);
                        setValue("masterId", value?.master_id);
                      }}
                      error={errors?.buyerId?.message}
                      register={register("buyerId", {
                        required: "Please select buyer id.",
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputField
                      disabled={true}
                      label={"Auctioneer"}
                      placeholder={"Auctioneer"}
                      register={register("auctioneer")}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
        <Grid item xs={12} ml={2} mr={2}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Accordion
            expanded={!!expanded.vehicle}
            onChange={handleChange("vehicle")}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Vehicle Details*</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={4}>
                  <DatePicker
                    label={"Purchase Date*"}
                    value={purchaseDate}
                    error={errors?.purchaseDate?.message}
                    register={register("purchaseDate", {
                      required: "Please select purchase date",
                    })}
                    onChange={(date) => handlePurchaseDate(date)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputField
                    label={"VIN*"}
                    placeholder={"VIN"}
                    error={errors?.vin?.message}
                    register={register("vin", {
                      required: "Please enter VIN.",
                      pattern: {
                        value: /^[^\-_]*$/,
                        message:
                          "VIN cannot contain hyphens (-) or underscores (_).",
                      },
                      onChange: (e) => {
                        const trimmedVin = e.target.value.trim();
                        if (trimmedVin.length == 20) {
                          setVinLength(false);
                        } else {
                          setVinLength(true);
                          handleBooking(trimmedVin);
                        }
                        setValue("vin", trimmedVin);
                      },
                    })}
                  />
                  {vinLength ? (
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 700,
                        fontFamily: FontFamily.NunitoRegular,
                        color: "red",
                      }}
                    >
                      Vin can be 20 Characters Long
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputField
                    label={"LOT*"}
                    placeholder={"Lot"}
                    error={errors?.lotNumber?.message}
                    register={register("lotNumber", {
                      required: "Please enter lot number.",
                      onChange: (e) => {
                        const trimmedLotNumber = e.target.value.trim();
                        setValue("lotNumber", trimmedLotNumber);
                      },
                    })}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <SelectField
                    label={"Currency*"}
                    options={currencies}
                    selected={selectedCurrency}
                    onSelect={(value) => {
                      setValue("bookingRate", value?.rate);
                      setSelectedCurrency(value);
                    }}
                    type={"text"}
                    error={errors?.currency?.message}
                    register={register("currency", {
                      required: "Please select currency.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputField
                    label={"Booking Rate*"}
                    placeholder={"Booking Rate"}
                    type={"text"}
                    step={"any"}
                    disabled={true}
                    // defaultValue={cadExRate}
                    error={errors?.value?.message}
                    register={register("bookingRate", {
                      // required: "Please enter value.",
                      pattern: {
                        value: numberRegex,
                        // message: "Please enter a valid number.",
                      },
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputField
                    label={"Vehicle Value*"}
                    placeholder={"Vehicle Value"}
                    type={"text"}
                    step={"any"}
                    error={errors?.value?.message}
                    register={register("value", {
                      required: "Please enter value.",
                      onChange: (e) => {
                        let priceAmount = e.target.value.replace(/,/g, "");

                        setValue("value", priceAmount);

                        if (
                          !(
                            !priceAmount ||
                            priceAmount.match(/^\d{1,}(\.\d{0,2})?$/)
                          )
                        ) {
                          setValue("value", parseFloat(priceAmount).toFixed(2));
                        }
                      },
                      pattern: {
                        value: numberRegex,
                        message: "Please enter a valid number.",
                      },
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputField
                    type={"text"}
                    label={"Other Charges"}
                    placeholder={"Other Charges"}
                    InputProps={{ inputProps: { min: 0 } }}
                    register={register("otherCharges", {
                      // required: "Please enter value.",
                      onChange: (e) => {
                        const priceAmount = e.target.value.replace(/,/g, "");
                        setValue("otherCharges", priceAmount);

                        if (
                          !(
                            !priceAmount ||
                            priceAmount.match(/^\d{1,}(\.\d{0,2})?$/)
                          )
                        ) {
                          setValue(
                            "otherCharges",
                            parseFloat(priceAmount).toFixed(2),
                          );
                        }
                      },
                      pattern: {
                        value: numberRegex,
                        message: "Please enter a valid number.",
                      },
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <InputField
                    label={"Notes"}
                    placeholder={"Notes"}
                    register={register("notes")}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={12} ml={2} mr={2}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Accordion
            expanded={!!expanded.Spec}
            onChange={handleChange("Spec")}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Vehicle Specification*</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    label={"Vehicle Type"}
                    options={rateTypeOptions}
                    selected={selectedRate}
                    error={errors?.rateType?.message}
                    register={register("rateType", {
                      required: "Please select type.",
                    })}
                    onSelect={(value) => setSelectedRate(value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createModel(newValue)}
                    onSearch={(v) => getModels(selectedMake?.id, v)}
                    label={"Model*"}
                    options={models}
                    selected={selectedModel}
                    onSelect={(value) => setSelectedModel(value)}
                    error={errors?.model?.message}
                    register={register("model", {
                      required: "Please select model.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createMake(newValue)}
                    onSearch={(v) => getMakes(v)}
                    label={"Make*"}
                    options={makes}
                    selected={selectedMake}
                    onSelect={(value) => {
                      setSelectedMake(value);
                      getModels(value?.id);
                      // setSelectedModel(null);
                    }}
                    error={errors?.make?.message}
                    register={register("make", {
                      required: "Please select make.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createColor(newValue)}
                    onSearch={(v) => getColors(v)}
                    label={"Color*"}
                    options={colors}
                    selected={selectedColor}
                    onSelect={(value) => setSelectedColor(value)}
                    error={errors?.color?.message}
                    register={register("color", {
                      required: "Please select color.",
                    })}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <SelectField
                    label={"Country*"}
                    options={countries}
                    selected={selectedCountry}
                    onSelect={(value) => {
                      setSelectedCountry(value);
                      getStates(value?.id);
                      setSelectedState(null);
                      setSelectedCity(null);
                    }}
                    error={errors?.country?.message}
                    register={register("country", {
                      required: "Please select country.",
                    })}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <SelectField
                    onSearch={(v) => getStates(selectedCountry?.id, v)}
                    disabled={selectedCountry ? false : true}
                    label={"Location"}
                    options={states}
                    selected={selectedState}
                    onSelect={(value) => {
                      setSelectedState(value);
                      setSelectedCity(null);
                    }}
                    // register={register("state & City", {
                    //     required: "Please select Location.",
                    // })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputField
                    label={"Off Site"}
                    placeholder={"Off Site"}
                    register={register("offSite")}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={12} ml={2} mr={2}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Accordion
            expanded={!!expanded.title}
            onChange={handleChange("title")}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Title & Keys</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={4} sm={4}>
                  <Grid item xs={12}>
                    <SelectField
                      onSearch={(v) => handleTitleStatusSearch(v)}
                      label={"Title Name"}
                      options={filteredTitleStatus}
                      selected={selectedTitleStatus}
                      onSelect={(value) => setSelectedTitleStatus(value)}
                      register={register("titleStatus")}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DatePicker
                      label={"Title Receive Date"}
                      value={titleReceiveDate}
                      onChange={(date) => handleTitleReceiveDate(date)}
                    />
                  </Grid>
                  <Grid item xs={12} mt={1}>
                    <InputField
                      label={"GP PIN"}
                      placeholder={"GP PIN"}
                      register={register("gpPin")}
                    />
                  </Grid>

                  <Grid item xs={12} sx={{ display: "flex" }}>
                    <InputLabel sx={{ marginTop: "10px", marginRight: "10px" }}>
                      Title Status
                    </InputLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={titleStatus}
                        onChange={(e) => setTitleSatus(e.target.value)}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                        <FormControlLabel
                          value="N/A"
                          control={<Radio />}
                          label="None"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sx={{ display: "flex" }}>
                    <InputLabel sx={{ marginTop: "10px", marginRight: "10px" }}>
                      Title Issue
                    </InputLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={titleIssue}
                        onChange={(e) => setTitleIssue(e.target.value)}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  {titleIssue === "yes" && (
                    <Grid mt={1.5}>
                      <InputField
                        label={"Title Issue Description"}
                        placeholder={"Title Issue Description"}
                        multiline={true}
                        rows={3}
                        register={register("titleDescription")}
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid
                  item
                  xs={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Divider
                    orientation="vertical"
                    flexItem
                    mx={1}
                    sx={{ borderColor: "#B3B3B3" }}
                  />
                </Grid>

                <Grid item xs={6} sm={6}>
                  <Grid item xs={12} sx={{ display: "flex" }}>
                    <InputLabel sx={{ marginTop: "10px", marginRight: "10px" }}>
                      Vehicle Key
                    </InputLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={vehicleKey}
                        onChange={(e) => setVehicleKey(e.target.value)}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                        <FormControlLabel
                          value="N/A"
                          control={<Radio />}
                          label="None"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sx={{ display: "flex" }}>
                    <InputLabel sx={{ marginTop: "10px", marginRight: "10px" }}>
                      Key Lost
                    </InputLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={keyLost}
                        onChange={(e) => setKeyLost(e.target.value)}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sx={{ display: "flex" }}>
                    <InputLabel sx={{ marginTop: "10px", marginRight: "10px" }}>
                      Veh. cancelled
                    </InputLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={vehicleCancell}
                        onChange={(e) => setVehicleCancell(e.target.value)}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sx={{ display: "flex" }}>
                    <InputLabel sx={{ marginTop: "10px", marginRight: "10px" }}>
                      Veh. Relist
                    </InputLabel>
                    <FormControl>
                      <RadioGroup
                        row
                        value={vehicleRelist}
                        onChange={(e) => setVehicleRelist(e.target.value)}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {vehicleRelist === "yes" && (
                    <Grid mt={1.5}>
                      <InputField
                        label={"Relist Reason"}
                        placeholder={"Relist Reason"}
                        register={register("relistReason")}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={12} ml={2} mr={2}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Accordion
            expanded={!!expanded.info}
            onChange={handleChange("info")}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Additional Information</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createOdometers(newValue)}
                    onSearch={(v) => getOdometers(v)}
                    label={"Odometers"}
                    options={odometers}
                    selected={selectedOdometers}
                    onSelect={(value) => setSelectedOdometers(value)}
                    // error={errors?.odoMeters?.message}
                    register={register("odoMeters", {
                      // required: "Please select model.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createCylinders(newValue)}
                    onSearch={(v) => getCylinders(v)}
                    label={"Cylinders"}
                    options={cylinders}
                    selected={selectedCylinders}
                    onSelect={(value) => setSelectedCylinders(value)}
                    // error={errors?.cylinders?.message}
                    register={register("cylinders", {
                      // required: "Please select cylinders.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createDrivetrain(newValue)}
                    onSearch={(v) => getDrivetrain(v)}
                    label={"Drivetrain"}
                    options={drivetrain}
                    selected={selectedDrivetrain}
                    onSelect={(value) => setSelectedDrivetrain(value)}
                    // error={errors?.drivetrain?.message}
                    register={register("drivetrain", {
                      // required: "Please select drivetrain.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createFuel(newValue)}
                    onSearch={(v) => getFuel(v)}
                    label={"Fuel"}
                    options={fuel}
                    selected={selectedFuel}
                    onSelect={(value) => setSelectedFuel(value)}
                    // error={errors?.fuel?.message}
                    register={register("fuel", {
                      // required: "Please select make.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createEngineType(newValue)}
                    onSearch={(v) => getEngineType(v)}
                    label={"Engine Type"}
                    options={engineType}
                    selected={selectedEngineType}
                    onSelect={(value) => setSelectedEngineType(value)}
                    // error={errors?.engineType?.message}
                    register={register("engineType", {
                      // required: "Please select Engine.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createTransmission(newValue)}
                    onSearch={(v) => getTransmission(v)}
                    label={"Transmission"}
                    options={transmission}
                    selected={selectedTransmission}
                    onSelect={(value) => setSelectedTransmission(value)}
                    // error={errors?.transmission?.message}
                    register={register("transmission", {
                      // required: "Please select transmission.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createHighlights(newValue)}
                    onSearch={(v) => getHighlights(v)}
                    label={"Highlights"}
                    options={highlights}
                    selected={selectedHighlights}
                    onSelect={(value) => setSelectedHighlights(value)}
                    // error={errors?.highlights?.message}
                    register={register("highlights", {
                      // required: "Please select make.",
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectField
                    addNew={(newValue) => createPrimaryDamage(newValue)}
                    onSearch={(v) => getPrimaryDamage(v)}
                    label={"Primary Damage"}
                    options={primaryDamage}
                    selected={selectedPrimaryDamage}
                    onSelect={(value) => setSelectedPrimaryDamage(value)}
                    // error={errors?.primaryDamage?.message}
                    register={register("primaryDamage", {
                      // required: "Please select make.",
                    })}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={12} ml={2} mr={2}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Accordion
            expanded={!!expanded.Attachment}
            onChange={handleChange("Attachment")}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Vehicle Pictures/Attachments*</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={12} sm={12}>
                  <AttachmentsCard
                    onPickFiles={handleUploadDocument}
                    onGetImages={() => console.log("Get Images clicked")}
                    images={pictures}
                    onRemove={removePicture}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <SelectField
                    label="Auction Invoice"
                    options={[
                      {
                        id: 1,
                        name: "At the time of purchase",
                      },
                      {
                        id: 2,
                        name: "At the time of delivery",
                      },
                    ]}
                    selected={invoiceType}
                    onSelect={(value) => {
                      setInvoiceType(value);
                    }}
                    // error={errors?.customer?.message}
                    register={register("periodicInvoice", {
                      // required: "Please select invoice.",
                    })}
                  />
                </Grid>

                <Grid item xs={12} sm={3} mt={3.7}>
                  <UploadFile
                    custom={true}
                    style={{
                      backgroundColor: "#e7efeb",
                      width: "100%",
                      height: "40px",
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "20px",
                      border: "1px dashed #aeb1b0",
                      borderRadius: "10px",
                    }}
                    register={register("scanned", {
                      onChange: (e) => handleUploadDocumentInvoices(e),
                    })}
                  />
                  {/* <UploadFile
                                        custom={true}
                                        multiple={true}
                                        style={{
                                            backgroundColor: "#e7efeb",
                                            width: "100%",
                                            height: "60px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "20px",
                                            border: "1px dashed #aeb1b0",
                                            borderRadius: "10px",
                                        }}
                                        accept={allowFilesType}
                                        error={errors?.scanned2?.message}
                                        register={register("invoices", {
                                            // required: "Please attach Decelaration.",
                                            onChange: (e) => handleUploadDocumentInvoices(e),
                                        })}
                                    /> */}
                </Grid>
                <Grid item xs={12} sm={1} sx={{ textAlign: "right" }} mt={4}>
                  <IconButton
                    size="small"
                    onClick={handleAddDocument}
                    sx={{
                      bgcolor: Colors.primary,
                      color: Colors.white,
                      "&:hover": {
                        bgcolor: Colors.primary,
                        color: Colors.white,
                      },
                    }}
                  >
                    <Add />
                  </IconButton>
                </Grid>

                {invoiceList.length > 0 ? (
                  <>
                    <Grid item xs={12} sm={12}>
                      <TableContainer component={Paper}>
                        <Table
                          sx={{ minWidth: 650 }}
                          aria-label="Documents Table"
                        >
                          <TableHead
                            sx={{
                              bgcolor: Colors.primary,
                              color: Colors.white,
                            }}
                          >
                            <TableRow>
                              <Cell>Invoice Type</Cell>
                              <Cell>Attachment</Cell>
                              <Cell>Action</Cell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoiceList.map((doc) => (
                              <TableRow key={doc?.id}>
                                <TableCell>{doc?.invoiceTypeName}</TableCell>
                                <TableCell>
                                  {doc?.documentLink2 && doc?.documentLink2 ? (
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        downloadAllAttachments(
                                          doc?.documentLink2,
                                        )
                                      }
                                    >
                                      <FiDownload
                                        color={Colors.primary}
                                        size={25}
                                      />
                                    </div>
                                  ) : (
                                    <FiDownload color="gray" size={25} />
                                  )}
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    aria-label="delete document"
                                    onClick={() => handleDeleteDocument(doc.id)}
                                    sx={{ color: Colors.danger }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        {/* <Grid item xs={12} ml={2} mr={2}>
                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid> */}

        <Box
          sx={{
            bottom: 0,
            pt: 2,
            mt: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <PrimaryButton title="Update" type="submit" loading={loading} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default UpdateVehicleBookingV2;
